import { create } from 'zustand';
import { UserSession } from 'features/rosie';
import storage from 'utils/storage';

export type UserSessionStoreState = {
  user: UserSession | null;
  storedEmail: string;
  history: string[];
  setStoredEmail: (email: string) => void;
  clearStoredEmail: () => void;
  setUser: (user: UserSession) => void;
  logout: () => void;
};

const initialStoredEmail = storage.getLoginEmail() || '';

const useUserStore = create<UserSessionStoreState>(set => ({
  user: null,
  storedEmail: initialStoredEmail,
  history: [],
  setStoredEmail: email => {
    if (email) {
      storage.setLoginEmail(email);
      set({ storedEmail: email });
    }
  },
  clearStoredEmail: () => {
    storage.clearLoginEmail();
    set({ storedEmail: '' });
  },
  setUser: user => {
    if (user) set({ user });
  },
  logout: () => set({ user: null }),
}));

export default useUserStore;
